'use client';

import { Combobox } from '@ctct/summit-extended';
import { type ComponentProps } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { type InputOpts } from '../../types';

const ComboboxWrapper = ({
  field: { name, value, onChange },
  items = [],
  onChange: handleOnChange,
  isMultiSelect = false,
  ...comboboxProps
}: {
  field: {
    name: string;
    value: string;
    onChange: (value: string | string[] | undefined) => void;
  };
  isMultiSelect?: boolean;
} & Omit<ComponentProps<typeof Combobox>, 'isMultiSelect' | 'selected'>) => {
  const handleChange = (value: string | string[] | undefined) => {
    onChange(value);
    if (handleOnChange) handleOnChange(value as string & string[]);
  };

  return (
    <Combobox
      key={name}
      selected={value}
      isMultiSelect={isMultiSelect}
      items={items}
      onChange={handleChange}
      {...comboboxProps}
    />
  );
};

const ComboboxInput = ({
  formKey,
  registerOpts,
  onChange: handleOnChange,
  isMultiSelect,
  items = [],
  ...comboboxProps
}: InputOpts
  & Omit<ComponentProps<typeof Combobox>, 'selected' | 'isMultiSelect'> & {
    isMultiSelect?: boolean;
  }) => {
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={formKey}
      rules={registerOpts}
      render={({ field }) => (
        <ComboboxWrapper
          isMultiSelect={isMultiSelect}
          onChange={handleOnChange}
          field={field}
          items={items}
          {...comboboxProps}
        />
      )}
    />
  );
};

export { ComboboxInput };
